import { useTranslation } from "react-i18next";

import {
  Button,
  Stack,
  Card,
} from "react-bootstrap";

import "./loginWrapper.css";
import {
  LOGIN_IMAGE1,
  LOGIN_VECTOR2,
  LOGIN_VECTOR3,
} from "../../../../assets/images";
import HelpVideo from "../../../../components/HelpVideo/HelpVideo";
import { isRTL } from "../../../../locales";

function LoginWrapper() {
  const { t } = useTranslation();
  const redirectToGovLogin = () => {
    window.location.href = "https://us-central1-mylexisplus-2f66b.cloudfunctions.net/app/api/gov-login?device=web";
  };

  const rtlBox = isRTL() ? "rtlBox" : "";

    return (
      <div className={`loginWrapper ${rtlBox}`}>

        {/* land page main title */}
        <div style={{ textAlign: isRTL() ? "right" : "left" }}>
          <h1 className="title">
            {t("t1")}
            <span> My Lexis Plus </span>
          </h1>

          {/* siginin,video buttons wrapper */}
          <Stack
            direction="horizontal"
            gap={3}
            className="mt-5"
            style={{ flexDirection: isRTL() ? "row-reverse" : "row" }}
          >
            <Button onClick={redirectToGovLogin}>Login with Gov ID</Button>

            <HelpVideo />
          </Stack>
        </div>

        <div className="loginImageWrapper mb-5">
          <img src={LOGIN_IMAGE1} className="loginImage1" alt="loginImage1" />
          <Card className="homeworkCard">
            <Card.Body>
              <Stack
                direction="horizontal"
                gap={2}
                style={{ flexDirection: isRTL() ? "row-reverse" : "row" }}
              >
                <img src={LOGIN_VECTOR2} alt="LOGIN_VECTOR2" />
                <Stack
                  style={{ alignItems: isRTL() ? "flex-end" : "flex-start" }}
                >
                  <h3>{t("t5")}</h3>
                  <p>{t("t6")}</p>
                </Stack>
              </Stack>
            </Card.Body>
          </Card>

          <Card className="examCard mt-2">
            <Card.Body>
              <Stack
                direction="horizontal"
                gap={2}
                style={{ flexDirection: isRTL() ? "row-reverse" : "row" }}
              >
                <img src={LOGIN_VECTOR3} alt="LOGIN_VECTOR3" />
                <Stack
                  style={{ alignItems: isRTL() ? "flex-end" : "flex-start" }}
                >
                  <h3>{t("t7")}</h3>
                  <p>{t("t8")}</p>
                </Stack>
              </Stack>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
}

export default LoginWrapper;
